<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Products</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.products.index')">
                                    Products
                                </Link>
                            </li>
                            <li class="breadcrumb-item active"> {{ isEditing ? "Edit" : "Add" }} Product
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">

                <div class="card-body">
                    <form @submit.prevent="saveProduct" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Product Name</label>
                                        <input type="text" v-model="product.name" class="form-control"
                                               placeholder="Product Name"
                                               required>
                                        <div v-if="product.errors.name" class="text-danger text-small">
                                            {{ product.errors.name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Product Images</label>
                                        <div class="row">
                                            <div class="col-3" v-for="(image, key) in product.images"
                                                 :key="key">
                                                <a :href="image.image" target="_blank">
                                                    <img :src="image.image_thumbnail"
                                                         :alt="product.name +' Image'"
                                                         class="img-thumbnail img-fluid"
                                                         style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                                                </a>
                                            </div>
                                        </div>
                                        <button type="button" data-toggle="modal" data-target="#gallery-modal"
                                                class="form-control"> {{ product.images ? 'Change' : 'Choose' }}
                                            Product Image
                                        </button>
                                        <div v-if="product.errors.images" class="text-danger text-small">
                                            {{ product.errors.images }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Category</label>
                                        <select v-model="product.category_id" id="" class="form-control" required>
                                            <option value="" selected>Select a Category</option>
                                            <option v-for="category in categories" :key="category.id"
                                                    :value="category.id">
                                                {{ category.name }}
                                            </option>
                                        </select>
                                        <span v-if="product.errors.category_id"
                                              class="text-danger text-small">{{ product.errors.category_id }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <textarea
                                            v-model="product.description"
                                            placeholder="Enter something..."
                                            rows="3"
                                            class="form-control"
                                            required
                                        ></textarea>
                                        <div v-if="product.errors.description" class="text-danger text-small">
                                            {{ product.errors.description }}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="col-12 col-sm-6">
                                <template v-if="!isEditing">
                                    <div class="form-group">
                                        <div class="controls">
                                            <label class="form-label">Product Sizes</label>
                                            <v-select multiple v-model="product.size_ids" :options="sizes"
                                                      label="name" :reduce="size => size.id"></v-select>
                                            <span v-if="product.errors.size_ids"
                                                  class="text-danger text-small">{{ product.errors.size_ids }}</span>
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" v-model="product.is_active"
                                                   id="defaultCheck1"
                                                   :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck1">
                                                Is this Product available?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.is_active"
                                              class="text-danger text-small">{{ product.errors.is_active }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck3"
                                                   v-model="product.has_toppings" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck3">
                                                Can this product have toppings?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.has_toppings"
                                              class="text-danger text-small">{{ product.errors.has_toppings }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck4"
                                                   v-model="product.is_drink" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck4">
                                                Is this product a drink/beverage?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.is_drink"
                                              class="text-danger text-small">{{ product.errors.is_drink }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck6"
                                                   v-model="product.has_crust" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck6">
                                                Can this product have crusts?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.has_crust"
                                              class="text-danger text-small">{{ product.errors.has_crust }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck2"
                                                   v-model="product.is_new" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck2">
                                                Is this Product new?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.is_new"
                                              class="text-danger text-small">{{ product.errors.is_new }}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck5"
                                                   v-model="product.chatbot_only" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck5">
                                                Is this product meant for the chatbot only?
                                            </label>
                                        </div>
                                        <span v-if="product.errors.chatbot_only"
                                              class="text-danger text-small">{{ product.errors.chatbot_only }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Product Ingredients</label>
                                        <v-select multiple v-model="product.ingredients" :options="ingredients"
                                                  label="name" :reduce="name => name.id"></v-select>
                                        <span v-if="product.errors.stores"
                                              class="text-danger text-small">{{ product.errors.ingredients }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Free Toppings</label>
                                        <v-select multiple v-model="product.free_toppings" :options="freeToppings"
                                                  label="topping_name" :reduce="name => name.id"></v-select>
                                        <span v-if="product.errors.free_toppings"
                                              class="text-danger text-small">{{ product.errors.free_toppings }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label class="form-label">Product Preparation Time (In minutes)</label>
                                        <input type="number" v-model="product.preparation_time" class="form-control"
                                               placeholder="Product Preparation Time">
                                        <span v-if="product.errors.preparation_time"
                                              class="text-danger text-small">{{ product.errors.preparation_time }}</span>
                                    </div>
                                </div>

                                <template v-if="!isEditing">
                                    <div class="form-group">
                                        <div class="controls">
                                            <label class="form-label">Available Stores</label>
                                            <v-select multiple v-model="selectedOptions" :options="availableStores"
                                                      label="name"
                                                      :reduce="name => name.id"></v-select>
                                            <span v-if="product.errors.stores"
                                                  class="text-danger text-small">{{ product.errors.stores }}</span>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <template v-if="!isEditing">
                                <div v-if="showStorePricing" class="col-12">
                                    <div class="form-group store-pricing-section">
                                        <label class="form-label d-block mb-1">Store Pricing</label>
                                        <p class="text-muted small mb-1">
                                            Set the price and optional discount price for each size at every selected store.
                                        </p>
                                        <div v-for="storeId in product.stores" :key="storeId"
                                             class="card store-pricing-card mb-1">
                                            <div class="card-header py-75 px-1">
                                                <strong>{{ getStoreName(storeId) }}</strong>
                                            </div>
                                            <div class="card-body p-1">
                                                <div class="row font-weight-bold small text-muted mb-50 d-none d-md-flex">
                                                    <div class="col-md-4">Size</div>
                                                    <div class="col-md-4">Price</div>
                                                    <div class="col-md-4">Discount Price</div>
                                                </div>
                                                <div v-for="sizeId in product.size_ids" :key="`${storeId}-${sizeId}`"
                                                     class="row align-items-center mb-75">
                                                    <div class="col-md-4 mb-50 mb-md-0">
                                                        <span class="d-md-none text-muted small">Size: </span>
                                                        {{ getSizeName(sizeId) }}
                                                    </div>
                                                    <div class="col-md-4 mb-50 mb-md-0">
                                                        <input type="number" min="0" step="0.01"
                                                               v-model="storePrices[storeId][sizeId].price"
                                                               class="form-control form-control-sm"
                                                               placeholder="Price" required>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <input type="number" min="0" step="0.01"
                                                               v-model="storePrices[storeId][sizeId].discount_price"
                                                               class="form-control form-control-sm"
                                                               placeholder="Discount price (optional)">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span v-if="product.errors.store_prices"
                                              class="text-danger text-small">{{ product.errors.store_prices }}</span>
                                    </div>
                                </div>
                            </template>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
        <gallery-modal @chooseImage="chosenImage" gallery-header="Add Images to Product Gallery" multiple-images="true"></gallery-modal>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Create Products'},
    name: 'ProductCreate',
    props: [
        'categories',
        'isEditing',
        'productData',
        'sizes',
        'stores',
        'ingredients',
        'freeToppings'
    ],
    components: {
        Link,
        GalleryModal
    },
    layout: Layout,
    data() {
        return {
            availableStores: [
                {
                    'name': "All Stores",
                    "id": "all",
                }
            ],
            product: this.$inertia.form({
                name: null,
                category_id: "",
                images: [],
                description: null,
                is_active: false,
                is_new: false,
                has_crust: false,
                has_toppings: false,
                size_ids: [],
                stores: [],
                store_prices: [],
                ingredients: [],
                preparation_time: null,
                is_drink: false,
                free_toppings: [],
                chatbot_only: false,
            }),
            saving: false,
            selectedOptions: [],
            storePrices: {},
        }
    },
    computed: {
        showStorePricing() {
            return !this.isEditing
                && this.product.stores.length > 0
                && this.product.size_ids.length > 0;
        },
    },
    watch: {
        selectedOptions(newVal) {
            if (newVal.includes('all')) {
                this.selectedOptions = this.availableStores
                    .filter((option) => option.id !== 'all')
                    .map((option) => option.id);
                this.product.stores = this.selectedOptions;
            } else {
                this.product.stores = this.selectedOptions;
            }
            this.syncStorePrices();
        },
        'product.size_ids'() {
            this.syncStorePrices();
        },
        'product.stores'() {
            this.syncStorePrices();
        },
    },
    methods: {
        getStoreName(storeId) {
            const store = this.stores.find((item) => item.id === storeId);

            return store ? store.name : 'Store';
        },
        getSizeName(sizeId) {
            const size = this.sizes.find((item) => item.id === sizeId);

            return size ? size.name : 'Size';
        },
        syncStorePrices() {
            if (this.isEditing) {
                return;
            }

            const updated = {};

            this.product.stores.forEach((storeId) => {
                updated[storeId] = {};

                this.product.size_ids.forEach((sizeId) => {
                    const existing = this.storePrices[storeId]?.[sizeId];

                    updated[storeId][sizeId] = existing ?? {
                        price: '',
                        discount_price: '',
                    };
                });
            });

            this.storePrices = updated;
        },
        buildStorePricesPayload() {
            const prices = [];

            this.product.stores.forEach((storeId) => {
                this.product.size_ids.forEach((sizeId) => {
                    const entry = this.storePrices[storeId]?.[sizeId] ?? {};

                    prices.push({
                        store_id: storeId,
                        size_id: sizeId,
                        price: entry.price,
                        discount_price: entry.discount_price || null,
                    });
                });
            });

            return prices;
        },
        chosenImage(images) {
            if(this.product.hasOwnProperty('images')){
                this.product.images = images;
            }
        },
        async saveProduct() {
            if (!this.isEditing) {
                this.product.store_prices = this.buildStorePricesPayload();
            }

            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('ul.navigation.navigation-main li.active').removeClass('active');
                },
                onError: () => {
                    this.saving = false;
                }
            };

             this.product.images = this.product.images.map(function(obj) {
                return obj.image;
            });

            if (this.isEditing) {
                this.product.post(route('admin.products.update', this.productData.id), options)

            } else {
                this.product.post(route('admin.products.store'), options);
            }
        }
    },
    mounted() {

        if (this.isEditing) {
            this.product.name = this.productData.name;
            this.product.category_id = this.productData.category_id;
            this.product.description = this.productData.description;
            this.product.is_new = this.productData.is_new;
            this.product.is_active = this.productData.is_active;
            this.product.has_crust = this.productData.has_crust;
            this.product.has_toppings = this.productData.has_toppings;
            this.product.is_drink = this.productData.is_drink;
            this.product.chatbot_only = this.productData.chatbot_only;
            this.product.ingredients = this.productData.ingredients.map(ingredient => ingredient.id)
            this.product.free_toppings = this.productData.free_toppings.map(topping => topping.id)
            this.product.preparation_time = this.productData.preparation_time;
            this.product.images = this.productData.product_images.map(function(obj) {
                let {  image_url, } = obj;
                return { image: image_url, image_thumbnail: image_url };
            });
            this.product.preparation_time = this.productData.preparation_time;
        }
        else {
            this.availableStores = [
                {
                    "id": "all",
                    "name": "All Stores",
                },
                ...this.stores
            ];
        }
    },
}
</script>

<style scoped>
.store-pricing-card .card-header {
    background-color: #f8f9fa;
}

.store-pricing-section .form-control-sm {
    min-height: calc(1.5em + 0.5rem + 2px);
}
</style>
